import * as React from "react";
import { forwardRef } from "react";
const SvgIcArrowTriangleFilled24 = ({
  title,
  titleId,
  ...props
}, ref) => /* @__PURE__ */ React.createElement("svg", { width: 24, height: 24, viewBox: "0 0 24 24", fill: "none", xmlns: "http://www.w3.org/2000/svg", ref, "aria-labelledby": titleId, ...props }, title ? /* @__PURE__ */ React.createElement("title", { id: titleId }, title) : null, /* @__PURE__ */ React.createElement("g", { id: "ic-arrowTriangleFilled-24" }, /* @__PURE__ */ React.createElement("path", { id: "Vector", d: "M12.5294 15.5303L18.5294 9.53033L17.9991 8.25H5.99908L5.46875 9.53033L11.4687 15.5303H12.5294Z", fill: "currentColor" })));
const ForwardRef = forwardRef(SvgIcArrowTriangleFilled24);
export { ForwardRef as ReactComponent };
